export default __webpack_public_path__ + "static/media/k2.c307963e.png";